import React from "react";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid2";
import { Typography, CardContent } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import integrationPartnersData from "../../data/integrationPartnersData";

const PREFIX = "IntegrationPartners";

const classes = {
  productTabLabel: `${PREFIX}-productTabLabel`,
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "1%"
  },
  title: {
    fontFamily: "AvenirLTStd-Roman",
    textAlign: "center",
    fontSize: 32,
  },
  divider: {
    borderBottom: "1px solid red",
    width: "30%",
    marginTop: 2,
    marginBottom: 1,
  },
  partnerContainer: {
    background: "#F0F8FF",
    padding: 2,
  },
  partnerGrid: {
    display: "flex",
    flexDirection: "column",
  },
  partnerImage: {
    width: "60%",
    height: "100px",
    objectFit: "cover",
  },
  cardContent: {
    flexGrow: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  description: {
    textAlign: "left",
    paddingBottom: 1,
  },
  readMoreLink: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    cursor: "pointer",
    textAlign: "left",
    fontFamily: "AvenirLTStd-Roman",
    color: "error.main",
  },
  icon: {
    marginLeft: 1,
  },
};

const StyledGrid = styled(Grid)(({ theme }) => ({}));

const StyledCardContent = styled(CardContent)(({ theme }) => ({
  ...classes.cardContent,
}));

const IntegrationPartners = () => {
  return (
    <StyledGrid container spacing={2}>
      <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={classes.container}>
        <Typography variant="h5" sx={classes.title}>
          Our Integration Partners
        </Typography>
        <Grid sx={classes.divider} />
      </Grid>
      <Grid container spacing={2} sx={classes.partnerContainer}>
        {integrationPartnersData &&
          integrationPartnersData.map((partner) => (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} key={partner.id}>
              <Grid sx={classes.partnerGrid}>
                <img
                  src={partner.imagePath}
                  alt={partner.description}
                  style={classes.partnerImage}
                />
                <StyledCardContent>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    component="p"
                    sx={classes.description}
                  >
                    {partner.description}
                  </Typography>
                  <Typography
                    variant="body2"
                    component="a"
                    href={partner.redirect}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={classes.readMoreLink}
                  >
                    Read More
                    <ArrowForwardIcon sx={classes.icon} />
                  </Typography>
                </StyledCardContent>
              </Grid>
            </Grid>
          ))}
      </Grid>
    </StyledGrid>
  );
};

export default IntegrationPartners;
